module.exports = {"attributes":{"viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M 0.611 19.174 L 19.759 5.292 L 38.908 19.174 L 19.759 33.056 L 0.611 19.174 Z\" fill=\"#B1BEC9\" stroke=\"#B1BEC9\"></path>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/conversion/other.svg
// module id = 1390
// module chunks = 0